import { cn } from '@/utils/tailwind-util';
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { OfficeBuildingIcon } from '@heroicons/react/outline/index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

import { useFetchClientListForPanel } from '@/services';

import { GroupStatus, STATUS_TEXT } from '../constants';
import { GroupModel } from '../model';
import { useChatStore } from '../store';
import { timeConverter } from '../utils';

interface Props {
  group: GroupModel;
}

const STYLES = {
  unselected:
    'flex min-h-[88px] cursor-pointer items-center gap-3 border-b-[1px] border-solid border-gray-200 px-4 hover:bg-gray-100 hover:text-gray-500',
  selected:
    'flex min-h-[88px] cursor-pointer items-center gap-3 border-b-[1px] border-solid border-gray-200 px-4 hover:text-gray-500 bg-gray-200 text-gray-500',
  [GroupStatus.CLOSED]:
    'min-h-10 min-w-10 flex items-center justify-center rounded-full text-xs font-semibold text-white bg-[#bbbec6]',
  [GroupStatus.PROCEEDING]:
    'min-h-10 min-w-10 flex items-center justify-center rounded-full text-xs font-semibold text-white bg-[#117a65]',
  [GroupStatus.WAITING]:
    'min-h-10 min-w-10 flex items-center justify-center rounded-full text-xs font-semibold text-white bg-[#22bcec]',
};

export const GroupItem = observer(({ group }: Props) => {
  const chatStore = useChatStore();
  const navigate = useNavigate();
  const { data } = useFetchClientListForPanel();
  const clientPanel = data?.content;

  const getOriginName = () => {
    let clientName = '';
    let venueName = '';
    clientPanel?.forEach((client) =>
      client.venues.forEach((venue) => {
        if (venue.id === group.venueId) {
          clientName = client.name;
          venueName = venue.name;
        }
      })
    );
    return { clientName, venueName };
  };
  const { clientName, venueName } = getOriginName();

  const handleClick = () => {
    // chat방 클릭시
    if (
      window.matchMedia('(max-width: 768px)').matches &&
      group.venueId &&
      group.id
    ) {
      navigate(`/chat/venue/${group.venueId}/group/${group.id}`, {
        state: {
          title: group.title,
          clientName,
          venueName,
          groupStatus: group.status,
        },
      });
      // chatStore.init();
      // chatStore.currentGroup = group;
      return;
    }

    if (group.id === chatStore.currentGroup?.id) return;
    chatStore.init();
    chatStore.currentGroup = group;
  };
  const isSelected =
    chatStore.currentGroup?.id === group.id ? 'selected' : 'unselected';
  return (
    <li className={cn(STYLES[isSelected])} onClick={handleClick}>
      <div className={cn(STYLES[group.status])}>
        {STATUS_TEXT[group.status]}
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex items-center justify-between">
          <p className="w-[232px] text-base font-medium text-black truncate">
            {group.title}
          </p>
          {group.unread && <div className="h-2 w-2 rounded-full bg-red-500" />}
        </div>
        <div className="flex gap-1">
          <OfficeBuildingIcon width={12} color="#1c1c1e" />
          <p className="text-xs text-gray-900">{clientName}</p>
          <p className="text-xs text-gray-600">{venueName}</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="text-[13px] text-[#999999]">{`#${group.id}`}</div>
          <div className="text-xs text-[#99999999]">
            {timeConverter(group.at)}
          </div>
        </div>
      </div>
    </li>
  );
});
